<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- /////////////////////////////////////////////////////
            //    PANTALLA PRINCIPAL                            //
        ///////////////////////////////////////////////////////////    -->
    <v-row>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <AutocompleteComp text-label="Año escolar de postulación" v-model="parametros.admision" :items="listAdmisiones"
          item-text="ano_academico" item-value="id" return-object @change="GetCondiciones()" />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <AutocompleteComp text-label="Nivel" v-model="parametros.id_nivel" :items="listCondiciones"
          item-text="nivel.desc_nivel" item-value="id" return-object @change="GetGrados" />
      </v-col>

      <v-col cols="12" sm="6" md="3" class="py-0">
        <AutocompleteComp text-label="Grado" v-model="parametros.id_grado" :items="listGrados"
          item-text="grado.desc_grado" item-value="id" />
      </v-col>

      <v-col cols="12" sm="6" md="3" class="d-flex justify-end align-center">
        <ButtonComp @click="GetPostulantes()" text-button="Consultar" icon-but="fas fa-search" normal-button />
      </v-col>

      <v-col cols="12" c>
        <ComundataTablecomp :headers="Postulantesheaders" :items="items" sort-by="nombre_seccion" :whitSearch="search">
          <template v-slot>
            <ButtonComp @click="dialog = true" text-button="Historial de no admitidos" icon-but="fas fa-user"
              class-color="red" />
          </template>
          <!-- hide-default-header -->
          <template v-slot:customHeader>
            <thead>
              <tr>
                <th key="title_familiar" colspan="4" class="text-center header_datatable">
                  <span>DATOS DEL PADRE O MADRE DEL TITULAR. </span>
                </th>
                <th key="title_postulante" colspan="4" class="text-center header_datatable">
                  <span>DATOS DEL POSTULANTE </span>
                </th>
                <th key="title_add" colspan="2" class="text-start header_datatable">
                  <span></span>
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:apellidos_nombres_familiar="{ item }">
            <span> {{ `${item.familiar.ape1_familiar} ${item.familiar.ape2_familiar}` }} <br>
              {{ `${item.familiar.nombre_familiar}` }}</span>
          </template>

          <template v-slot:apellidos_nombres_postulante="{ item }">
            <span>{{ `${item.ape1_postulante} ${item.ape2_postulante}` }} <br> {{ `${item.nombre_postulante}` }}</span>
          </template>

          <template v-slot:id_estado_postulante="{ item }">
            <v-chip v-if="item.id_estado_postulante == 1" dark class="font-weight-black" color="primary">Por
              admitir</v-chip>
            <v-chip v-else-if="item.id_estado_postulante == 3" dark class="font-weight-black"
              color="red">Rechazado</v-chip>
            <v-chip v-else-if="item.id_estado_postulante == 2" dark class="font-weight-black"
              color="green">Admitido</v-chip>

          </template>

          <template v-slot:action="{ item }">

            <v-menu open-on-hover :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
                  <v-icon>
                    fa-ellipsis-v
                  </v-icon>
                </v-btn>
              </template>

              <v-list mandatory>
                <v-list-item @click="ViewFile(item)">
                  <v-list-item-icon>
                    <v-icon color="green">fas fa-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Emitir constancia de vacante</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="componenteEvento.editar_submodulo" :disabled="item.id_estado_postulante != '1'"
                  @click="Admitir(item)">
                  <v-list-item-icon>
                    <v-icon color="primary">fa-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Admitir</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="verItem(item)">
                  <v-list-item-icon>
                    <v-icon color="green">fa-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Visualizar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="componenteEvento.borrar_submodulo" :disabled="item.id_estado_postulante != '1'"
                  @click="Rechazar(item)">
                  <v-list-item-icon>
                    <v-icon color="red">
                      fa-trash-alt
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Rechazar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>


    <ComunDialogComp v-model="dialog" @close-modal="dialog = false" title="Reporte de postulantes no admitidos"
      max-width="1500px">

      <template v-slot:body>
        <v-row>
          <v-col cols="12" class="d-flex flex-row-reverse">
            <ButtonComp @click="DeletePostulantsRejected()" text-button="Eliminar" icon-but="fas fa-trash" normal-button
              class-color="red" />
          </v-col>
          <v-col cols="12">
            <ComundataTablecomp :headers="RelacionpostulantesHeaders" :items="items2" whitSelect
              v-model="postulantsDeleted" sort-by="nombre_seccion">
              <template v-slot:customHeader>
                <thead>
                  <tr>
                    <th key="title_add" colspan="1" class="text-start header_datatable">
                      <span></span>
                    </th>
                    <th key="title_familiar" colspan="5" class="text-center header_datatable">
                      <span>DATOS DEL PADRE O MADRE DEL TITULAR</span>
                    </th>
                    <th key="title_postulante" colspan="6" class="text-center header_datatable">
                      <span>DATOS DEL POSTULANTE </span>
                    </th>
                  </tr>
                </thead>
              </template>

            </ComundataTablecomp>
          </v-col>
        </v-row>
      </template>
    </ComunDialogComp>


    <v-row>
      <v-col cols="12">

      </v-col>
    </v-row>

    <DetallePostulante v-if="editedItem.id" @close="cerrarModal" :estado="compEstado" :postulante="editedItem">
    </DetallePostulante>

    <!----- modal confirmacion para rechazar -->
    <confirm @aceptar="RechazarPostulacion" @cancelar="clear_confirm" :title="confirmRechazar.title"
      :active="confirmRechazar.active" />

    <!----- modal confirmacion para admitir  -->
    <confirm @aceptar="AdmitirPostulacion" @cancelar="clear_confirm" :title="confirmAdmitir.title"
      :active="confirmAdmitir.active" />
  </div>
</template>



<script>
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import moment from "moment";
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import DetallePostulante from "@/views/Mantenimiento/RelacionPostulantes/components/DetallePostulante.vue";
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import { RelacionpostulantesHeaders, Postulantesheaders } from '../../../helpers/headersTable';

export default {
  name: "relacionPostulante",

  components: {
    DetallePostulante,
    AutocompleteComp,
    ComundataTablecomp,
    ButtonComp,
    ComunDialogComp
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 142, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    consultaActiva: false,
    RelacionpostulantesHeaders,
    Postulantesheaders,
    dataFile: {},
    // modal detalles
    dialog: false,
    compEstado: false,
    search: "",
    confirmRechazar: {
      title: "",
      active: false,
    },
    confirmAdmitir: {
      title: "",
      active: false,
    },
    postulantsDeleted: [],
    parametro: {},
    // consulta princial
    items: [],
    items2: [], //Postulantes Rechazados de todos los años
    itemsArray: [],


    id_pdf: "",
    bucket: {},
    listAdmisiones: [],
    sucursales: [],
    listCondiciones: [],
    listGrados: [],
    doc: "",

    parametros: {
      id_colegio: sessionStorage.id_colegio,
      id_admision: "",
      admision: {},
      id_nivel: "",
      id_grado: "",
    },

    editedItem: {
      id_colegio: sessionStorage.id_colegio,
      id_usuario: sessionStorage.id,
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  created() {
    this.actualizarParamentro();
    this.formatearFechas();
  },

  mounted() {
    this.GetAdmisiones();
    this.reporteNoAdmitidos();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    ...mapState(["datoColegio"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    clear_confirm() {
      this.confirmRechazar.title = "";
      this.confirmRechazar.active = false;
      this.confirmAdmitir.title = "";
      this.confirmAdmitir.active = false;
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    async ViewFile(item) {
      this.id_pdf = Object.assign({}, item);
      this.bucket.bucket = BUCKET_ORIGIN_SPACE

      try {
        const response = await axios.get(
          `/admision/postulante/generatePdf`,
          {
            params: {
              id: this.id_pdf.id,
              bucket: BUCKET_ORIGIN_SPACE,
              id_colegio: this.parametros.id_colegio,
            },
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "archivo.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async GetAdmisiones() {
      try {
        let response = await axios.get(
          `/admision/configuracion/${this.datoLogin.id_colegio}/?activo=true`
        );
        this.listAdmisiones = response.data;

      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    Admitir(item) {
      this.editedItem = Object.assign({}, item);
      this.confirmAdmitir.title = `Notificar por correo la aprobación del preregistro y mandarle las credenciales del usuario del estudiante.`;
      this.confirmAdmitir.active = true;
    },

    async AdmitirPostulacion() {
      console.log(this.editedItems)
      try {
        let response = await axios.post(
          `/admision/postulante/${this.editedItem.id}/admitir/`,
          {
            id_usuario: sessionStorage.id,
            id_colegio: sessionStorage.id_colegio,
          }
        );
        console.log(sessionStorage.id_colegio);
        if (response.data.messageT == "S") {
          this.clear_confirm();
          this.setEnviarMens({
            tipo: "S",
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
          this.GetPostulantes();
        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${response.data.message}`,
            tiempo: 20000,
          });
          this.clear_confirm();
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    Rechazar(item) {
      this.editedItem = Object.assign({}, item);
      this.confirmRechazar.title = `¿Esta seguro de que desea rechazar la postulacion de ${item.ape1_postulante} ${item.ape2_postulante} ${item.nombre_postulante}?`;
      this.confirmRechazar.active = true;
    },

    async RechazarPostulacion() {
      try {
        console.log(this.editedItem);
        let response = await axios.post(
          `/admision/postulante/${this.editedItem.id}/rechazar/`,
          this.editedItem
        );
        console.log(response);
        if (response.data.messageT == "S") {
          console.log(response);
          this.clear_confirm();
          this.setEnviarMens({
            tipo: "S",
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
          this.GetPostulantes();
          this.reporteNoAdmitidos();
        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `No se pudo rechazar la postulación`,
            tiempo: null,
          });
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async GetPostulantes() {
      try {
        let query = `?id_admision=${this.parametros.id_admision}&id_grado=${this.parametros.id_grado}&id_nivel=${this.parametros.id_nivel}`;
        let response = await axios.get(
          `/admision/postulante/${this.datoLogin.id_colegio}/${query}`
        );
        console.log("GET POSTULATES", response);
        this.itemsArray = response.data;
        this.formatearFechas();
        if (response.data == null || response.data == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No existe postulante para este grado",
            tiempo: null,
          });
          this.consultaActiva = false;
        } else {
          this.consultaActiva = true;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async reporteNoAdmitidos() {
      this.editedItem.selected = false;
      try {
        console.log(this.editedItem.id_colegio);
        let response = await axios.post(
          "/admision/postulanteRechazado/getAllRejectedPostulant",
          { id_colegio: this.editedItem.id_colegio }
        );
        console.log(response.data);

        //Array que renderiza los postulantes rechazados
        this.items2 = response.data.map((item) => {
          return {
            ...item,
            fecha_entrevista2: moment(item.fecha_entrevista).format('DD/MM/YYYY'),
            fecha_rechazo_postulacion: moment(item.fecha_rechazo_postulacion).format('DD/MM/YYYY')
          };
        });

      } catch (e) {
        console.error(e);
      }
    },

    async DeletePostulantsRejected() {
      try {
        console.log(this.postulantsDeleted);
        const postulants = this.postulantsDeleted;
        console.log(postulants);
        if (postulants.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            message: `Debe seleccionar un estudiante primero.`,
            tiempo: null,
          });
          return;
        }
        //Condicional que indique que si no ha seleccionado ningun estudiante no puede s
        let response = await axios.delete(
          "/admision/postulanteRechazado/deleteRejectedPostulant",
          { params: { postulants: postulants } }
        );
        if (response.data.messageT == "S") {
          console.log(response);
          this.setEnviarMens({
            tipo: "S",
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
          this.GetPostulantes();
          this.reporteNoAdmitidos();
        } else if (response.data.messageT == "E") {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    formatearFechas() {
      this.items = this.itemsArray.map((item) => {
        return {
          ...item,
          fecha_entrevista: moment(item.fecha_entrevista).format("DD/MM/YYYY"),
        };
      });
    },

    async GetSucursalesColegio() {
      try {
        this.parametros.id_colegio = this.parametros.admision.id_colegio;
        this.parametros.id_admision = this.parametros.admision.id;
        this.listSucursales = [];
        this.listNiveles = [];
        this.listGrados = [];
        let response = await axios.get(
          `/manager/colegio/sucursales/${this.parametros.id_colegio}`
        );
        this.listSucursales = response.data;
        this.GetCondiciones();
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async GetCondiciones() {
      try {
        this.parametros.id_colegio = this.parametros.admision.id_colegio;
        this.parametros.id_admision = this.parametros.admision.id;
        this.parametros.id_nivel = "";
        this.parametros.id_grado = "";
        this.listGrados = [];
        this.listCondiciones = [];
        let response = await axios.get(
          `/admision/condicion/${this.datoLogin.id_colegio}?id_admision=${this.parametros.id_admision}`
        );
        this.listCondiciones = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async GetGrados(condicion) {
      this.parametros.id_nivel = condicion.id;
      this.parametros.id_grado = "";
      this.listGrados = condicion.grados;
    },

    cerrarModal() {
      // this.GetPostulantes();
      this.compEstado = false; //Cierra Modal
    },

    verItem(item) {
      console.log("datapostulante", item);
      this.editedItem = Object.assign({}, item);
      this.compEstado = true;
    },
  },
};
</script>




<style scoped>
#text {
  color: #ffffff;
  padding: 1%;
  padding-left: 10%;
}

.custom-table tbody tr:hover {
  background-color: #e4d5d5;
}

.theadAdd th {
  height: 32px !important;
}


@media (max-width: 600px) {
  .theadAdd {
    display: none;
  }
}
</style>
